import React from "react";

import { Modal, ModalProps } from "antd";

import Text from "@/common/Text/Text";

interface Props extends Omit<ModalProps, "title"> {
  children: React.ReactNode;
  title: React.ReactNode;
  open: boolean;
}

const BrandModal: React.FC<Props> = ({
  children,
  title,
  open,
  onCancel,
  ...props
}) => {
  return (
    <Modal
      title={
        typeof title === "string" ? (
          <Text type="title" size="lg">
            {title}
          </Text>
        ) : (
          title
        )
      }
      open={open}
      onCancel={onCancel}
      {...props}
    >
      {children}
    </Modal>
  );
};

export default BrandModal;
